import { createIcon } from '@chakra-ui/icons'

export const HeartIcon = createIcon({
  viewBox: '0 0 256 256',
  displayName: 'heart',
  path: (
    <path
      d='M128,216S28,160,28,92A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92C228,160,128,216,128,216Z'
      fill='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='24'
    />
  )
})
